import axios from "axios";
import { backendUrl } from "../../config/config";

const url = backendUrl + "/password";

const forgotPassword = async (data) => {
  try {
    const res = await axios.post(`${url}/forgot`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const resetPassword = async (data) => {
  try {
    const res = await axios.put(`${url}/reset`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

export { forgotPassword, resetPassword };